import React from "react";
import * as styles from "./reservation.css";

const Reservation: React.FC = () => {
  return (
    <section className={styles.container} id="reservation">
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <p className={styles.subTitle}>ご予約</p>
        <h2 className={styles.title}>Reservation</h2>
        <a
          href="https://app.squareup.com/appointments/book/qgq7fvn533lm8i/LDWB4KMXMDB4D/start"
          target="_top"
          rel="nofollow"
          className={styles.button}
        >
          オンライン予約はこちらから &gt;
        </a>
      </div>
    </section>
  );
};

export default Reservation;
